import React from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../../PageTemplate/ListFormTemplate";
import { transmission } from "../../../utils/config";
import useVehicleClassesLogic from "./useVehicleClassesLogic";

const columns = [
  { field: "id", label: "ID", allowSorting: true, decimalCount: 0 },
  { field: "name", label: "Name", allowSorting: true },
];

const VehicleClassesPage = () => {
  const { addRoles, deleteRoles, editRoles, apiRoute, initFields } =
    useVehicleClassesLogic();
  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to the Vehcile Categories." />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        // this one is used to fetch filter options , so i can do a single backend function to fetch for all pages
        tableNameInDb="vehicle_class"
        //
        apiRoute={apiRoute}
        columns={columns}
        fields={initFields}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
        enhancedTable={true}
      />
    </div>
  );
};

export default VehicleClassesPage;
